import React from 'react';
import { PublicationWall } from '@/features/publication-wall';
import { MOCK_POSTS, MOCK_EXISTING_TAGS } from '@/core/services/interfaces/PostMockData';

export const PublicationWallDevPage: React.FC = () => {
  return <PublicationWall posts={MOCK_POSTS} existingTags={MOCK_EXISTING_TAGS} />;
};
